<template>
  <v-card width="100%" tile elevation="0">
    <v-card-text class="py-1">
    <v-form ref="form">
      <v-row dense>
        <v-col v-for="(field, i) in form.status_finish.formulario.fields" :key="i"
              :cols="field.cols" :offset="field.offset" :hidden="field.hidden">
          <v-text-field v-if="field.field == 'text' && !field.hidden"
            v-model="model[field.nameid]"
            :disabled="field.disabled"
            :label="field.name"
            :type="field.type"
            :rules="(field.rules)? fieldRequired : []"
            outlined
            dense>
          </v-text-field>

          <v-text-field
            v-if="field.field == 'number' && !field.hidden"
            v-model.number="model[field.nameid]"
            :label="field.name"
            :type="field.type"
            min="0"
            :rules="field.rules ? fieldRequired : []"
            outlined
            dense>
          </v-text-field>

          <v-textarea v-else-if="field.field == 'textArea' && !field.hidden"
            v-model="model[field.nameid]"
            :label="field.name"
            :name="field.dimens"
            :rules="(field.rules)? fieldRequired : []"
            outlined
            dense>
          </v-textarea>

          <v-select v-else-if="field.field == 'select' && !field.hidden"
            v-model="model[field.nameid]"
            :label="field.name"
            :items="field.items"
            :rules="(field.rules)? fieldRequired : []"
            outlined
            dense>
          </v-select>

          <div v-else-if="field.field == 'radioButton' && !field.hidden">
            {{ isUpdate(field) }}
            <label class="black--text font-weight-bold font-weight-black subtitle-2">{{field.name}}</label>
            <v-radio-group
              v-model="model[field.nameid]"
              :row="field.row"
              :rules="(field.rules)? fieldRequired : []"
              class="pa-1 ma-1"
              @change="RadioButtonEvent(field)"
            >
              <v-radio
                v-for="(value,index) in field.items"
                :key="index"
                :label="(value.name)? value.name : value"
                :value="(value.name)? value.value : value"
              />
            </v-radio-group>
          </div>
          <div v-else-if="field.field == 'switch' && !field.hidden">
            <v-switch
              flat
              dense
              v-model="model[field.nameid]"
              :label="field.name"
              :rules="(field.rules) ? fieldRequired : []"
            >
            </v-switch>
          </div>

          <Checklist v-else-if="field.field == 'checklist'" :model="model" :tipo="model.tipo"></Checklist>

          <FileInputDinamicField v-else-if="field.field == 'fileInputDataServer' && !field.hidden"
              :itemAction="field"
              :setterModel="model"
              :on-success="actionFieldData"/>

          <SelectedMultipleDinamicField v-else-if="field.field == 'selectMultipleDataServer' && !field.hidden"
              :setterModel="model[field.nameid]"
              :itemAction="field"
              :on-success="actionFieldData"/>

          <div v-else-if="field.field == 'checkbox' && !field.hidden">
            <p v-if="field.name" class="ma-0 pa-0 text--black font-weight-bold font-weight-black subtitle-2">{{field.name}}</p>
              <v-checkbox v-for="value in field.items" :key="value" :class="(field.row)? 'mr-3 pa-0 checkbook-horizontal' : 'ma-0 pa-0'"
                v-model="model[field.nameid]"
                :label="(value.name) ? value.name : value"
                :value="(value.name) ? value.value : value"
                :rules="(field.rules) ? fieldRequired : []"
                >
              </v-checkbox>
          </div>

          <SelectedDinamicField v-else-if="field.field == 'selectDataServer' && !field.hidden"
            :setterModel="model[field.nameid]" :itemAction="field" :on-success="actionFieldData" />
            <SelectedGroupMain v-else-if="field.field == 'selectGroupDataServer' && !field.hidden"
            :setterModel="model[field.nameid]" :itemAction="field" :on-success="actionFieldData" />
          <DropMenuTreeView v-else-if="field.field == 'dropMenuTreeviewDataServer' && !field.hidden"
            :setterModel="model[field.nameid]" :itemAction="field" :on-success="actionFieldData" />
          <SearchDinamicField v-else-if="field.field == 'searchDataServer' && !field.hidden"
            :setterModel="model" :itemAction="field" :on-success="actionFieldData" />

            <DatePicker v-else-if="field.field == 'textDatePicker' && !field.hidden"
            :setterModel="model[field.nameid]"
            :itemAction="field"
            :on-success="actionFieldData"/>

            <TableDataField v-else-if="field.field == 'TableDataServer'&& !field.hidden"
              :setterModel="model[field.nameid]" :itemAction="field" :on-success="actionFieldData"/>

          <v-divider v-else-if="field.field == 'divider' && !field.hidden" class="dividerMain">
          </v-divider>
        </v-col>
      </v-row>
    </v-form>
  </v-card-text>
  <v-card-actions>
    <v-layout justify-end>
      <v-btn class="mr-3" color="red darken-1" depressed outlined @click="onCancel">Cerrar</v-btn>
      <v-btn class="mr-3" color="success darken-1"
        depressed
        outlined
        @click="sendForm"
        :loading="btnloading"
        :disabled="btnloading"> {{form.status_finish.nombre}}</v-btn>
    </v-layout>
  </v-card-actions>
</v-card>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { Validate } from '@/mixins/validateFormMixin'
import SelectedDinamicField from '@/components/fields/SelectedDinamicField'
import SelectedGroupMain from '@/components/fields/selectedGroupMain'
import DropMenuTreeView from '@/components/fields/DropMenuTreeView'
import SearchDinamicField from '@/components/fields/SearchDinamicField'
import DatePicker from '@/components/fields/DatePicker'
import SelectedMultipleDinamicField from '@/components/fields/SelectedMultipleDinamicField'
import Checklist from '@/components/checklist/checklist.vue'
import FileInputDinamicField from '@/components/fields/FileInputDinamicField'
import { xml2js } from 'xml-js'
import TableDataField from '@/components/fields/TableDataField'
export default {
  name: 'MainProcessForm',
  props: ['form', 'modelmain', 'update', 'onSuccess', 'onCancel'],
  mixins: [Validate],
  data: () => ({
    selected: [],
    model: {},
    btnloading: false
  }),
  components: {
    SelectedDinamicField,
    SelectedGroupMain,
    DropMenuTreeView,
    SearchDinamicField,
    DatePicker,
    SelectedMultipleDinamicField: SelectedMultipleDinamicField,
    Checklist: Checklist,
    FileInputDinamicField: FileInputDinamicField,
    TableDataField
  },
  created () {
    this.model = this.modelmain
  },
  methods: {
    ...mapActions([]),
    ...mapMutations(['SHOW_LOADING_MAIN', 'HIDDE_LOADING_MAIN']),
    isUpdate (field) {
      if (this.update) {
        this.RadioButtonEvent(field)
      } else {
        if (this.model[field.nameid]) this.RadioButtonEvent(field)
      }
    },
    RadioButtonEvent (item) {
      if (item.action) {
        this[item.action](item)
      }
    },
    ShowFieldDinamic (field) {
      const response = this.model[field.nameid]
      if (field.isHidden) {
        field.isHidden.map((item, i) => {
          this.form.status_finish.formulario.fields.map((form, index) => {
            if (item === form.nameid) {
              if (response === 'Programado') {
                form.hidden = false
                // this.model[form.nameid] = ''
                return
              } else if (field.nameid === 'retencion') {
                form.hidden = false
                this.model[form.nameid] = null
                return
              } else if (response === 'No Programado') {
                form.hidden = true
                if (!this.update) this.model[form.nameid] = ''

                return
              } else if (response && field.nameid === 'equipo_inventario') {
                form.hidden = (form.nameid !== 'inventario_id')
                // this.model[form.nameid] = (form.nameid === 'registrar_equipo') ? false : null
                return
              } else if (!response && field.nameid === 'equipo_inventario') {
                form.hidden = (form.nameid === 'inventario_id')
                if (!this.update) this.model[form.nameid] = (form.nameid === 'registrar_equipo') ? true : null
                return
              } else if (response && field.nameid === 'interno') {
                form.hidden = (form.nameid !== 'solicitante_id')
                // if (!this.update) this.model[form.nameid] = (form.nameid === 'registrar_solicitante') ? false : null
                return
              } else if (!response && field.nameid === 'interno') {
                form.hidden = (form.nameid === 'solicitante_id')
                if (!this.update) this.model[form.nameid] = (form.nameid === 'registrar_solicitante') ? true : null
                return
              } else if (response && field.nameid === 'buscar_persona') {
                form.hidden = (form.nameid !== 'empleado_recibe_id')
                return
              } else if (!response && field.nameid === 'buscar_persona') {
                form.hidden = (form.nameid === 'empleado_recibe_id')
                if (!this.update) this.model[form.nameid] = null
                return
              } else if (response) {
                form.hidden = false
                this.model[form.nameid] = null
                return
              }
              form.hidden = true
              this.model[form.nameid] = null
            }
          })
        })
      }
    },
    ShowAndHiddenContrato (field) {
      if (field.isHidden) {
        field.isHidden.map((item, i) => {
          this.form.status_finish.formulario.fields.map((form, index) => {
            if (item === form.nameid) {
              if (form.hidden && this.model[field.nameid] === 'si') {
                form.hidden = false
                this.model[form.nameid] = ''
              } else if (this.model[field.nameid] === 'no') {
                form.hidden = true
              }
            }
          })
        })
      }
    },
    SelectedAction (field) {
      if (field.id === 'contrato_id' || field.id === 'tipo_adquisicion_id') {
        if (field.action) {
          this[field.action](field)
        }
        if (field.fieldMain) {
          this[field.fieldMain.action](field)
        }
      }
    },
    // ShowRetencionSelected (field) {
    //   console.log('hide')
    //   if (field.fieldMain.isHidden) {
    //     field.fieldMain.isHidden.map((item, i) => {
    //       this.form.status_finish.formulario.fields.map((form, index) => {
    //         if (item === form.nameid) {
    //           if (this.model[field.fieldMain.nameid] && this.model[field.fieldMain.nameid] === 1) {
    //             form.hidden = false
    //             return
    //           }
    //           form.hidden = true
    //           this.model[form.nameid] = null
    //         }
    //       })
    //     })
    //   }
    // },
    ShowFieldDinamicComponent ({ data, fieldMain, id, objectMain }) {
      // console.log('data', data)
      const response = data
      if (fieldMain.isHidden) {
        fieldMain.isHidden.map((item, i) => {
          this.form.status_finish.formulario.fields.map((form, index) => {
            if (item === form.nameid) {
              if (form.nameid === 'direccion_id') {
                form.url = ''
                if (response) {
                  form.url = `${form.default}?id=${response}`
                  setTimeout(() => { form.hidden = false }, 200)
                } else {
                  setTimeout(() => { form.hidden = true }, 200)
                }
                this.model[form.nameid] = null
                return
              } else if (form.nameid === 'retencion') {
                form.hidden = !(response === fieldMain.validacion)
                this.model[form.nameid] = null
                return
              } else if (form.nameid === 'empleado') {
                if (response) {
                  form.url = `${form.default}/${response}`
                  setTimeout(() => { form.hidden = false }, 200)
                } else setTimeout(() => { form.hidden = true }, 200)

                this.model[form.nameid] = null
                return
              } else if (form.nameid === 'inventarios_id') {
                if (response) {
                  let params = '?'
                  if (form.params) {
                    Object.entries(form.params).forEach(([key, value]) => { params += (params === '?') ? `${key}=${value}` : `&${key}=${value}` })
                    params += `&${id}=${data}`
                    form.url = `${form.default}${params}`
                    setTimeout(() => { form.hidden = false }, 200)
                  }
                } else setTimeout(() => { form.hidden = true }, 200)
                this.model[form.nameid] = null
                return
              }
              form.hidden = true
              this.model[form.nameid] = null
            }
          })
        })
      }
    },
    checkboxEvent (item) {},
    actionFieldData (obj) {
      this.model[obj.id] = (obj.data) ? obj.data : null
      if (obj.view) { this.model[obj.view] = obj.viewText }
      // if (obj.id === 'documento_xml') { this.setXml(obj.data) }
      // if (obj.fieldMain) { this.SelectedAction(obj) }
      this.actionDinamicData(obj)
    },
    actionDinamicData (obj) {
      // console.log('obj', obj)
      if (obj.action) {
        this[obj.action](obj)
      } else if (obj.fieldMain && obj.fieldMain.action) {
        this[obj.fieldMain.action](obj)
      }
    },
    findBillEmployee ({ id, data, field }) {
      if (field.isHidden) {
        field.isHidden.map((item, i) => {
          this.form.status_finish.formulario.fields.map((form, index) => {
            if (item === form.nameid) {
              if (form.hidden) {
                form.params[id] = data
                form.hidden = false
                return
              }
              form.params = {}
              form.hidden = true
              this.model[form.nameid] = null
            }
          })
        })
      }
    },
    validateComponents () {
      let itemSelected = null
      this.form.status_finish.formulario.fields.map((item) => {
        if (item.rules) {
          if (!item.hidden) {
            if (!this.model[item.nameid]) {
              itemSelected = item
            } else if (this.model[item.nameid] === null) {
              itemSelected = item
            }
          }
        }
      })
      return itemSelected
    },
    sendForm () {
      if (this.$refs.form.validate()) {
        const item = this.validateComponents()
        if (item !== null) {
          this.$swal({
            type: 'error',
            icon: 'error',
            title: 'Advertencia!',
            text: ` Campo ${item.name} no debe ser vacio!!`
          })
          return
        }
        this.SHOW_LOADING_MAIN(true)
        this.onSuccess({
          descripcion: this.model,
          action: this.form.accion,
          status: this.form.estatus_final_id,
          actual: this.form.estatus_actual_id
        })
      }
    },
    setXml ({ id, data, fieldMain }) {
      const reader = new FileReader()
      if (!data) {
        // Mostrar campos ocultos en caso de tener valor
        fieldMain.isHidden.map((item, i) => {
          this.form.status_finish.formulario.fields.map((form, index) => {
            if (item === form.nameid) {
              this.model[form.nameid] = ''
              form.hidden = true
            }
          })
        })
        return
      }
      reader.readAsText(data)
      reader.onloadend = () => {
        const xmlObject = xml2js(reader.result).elements[0]
        let emisor = {}
        let timbreFiscalDigital = {}
        let estadoDeCuentaCombustible = {} // solo facturas con estados de cuenta
        let impuestos = { TotalImpuestosTrasladados: 0 }
        const conceptos = []
        const conceptosEdoCta = []
        let totalTrasladados = 0
        xmlObject.elements.forEach(function (o) {
          // datos del emisor
          if (o.name === 'cfdi:Emisor') {
            emisor = o.attributes
          }
          // datos del timbre fiscal
          if (o.name === 'cfdi:Impuestos') {
            impuestos = o.attributes
          }
          // datos del timbre fiscal
          if (o.name === 'cfdi:Complemento') {
            o.elements.forEach(function (c) {
              if (c.name === 'tfd:TimbreFiscalDigital') {
                timbreFiscalDigital = c.attributes
              }
              // datos del estado de cuenta
              if (c.name === 'ecc12:EstadoDeCuentaCombustible') {
                c.elements.forEach(function (c) {
                  if (c.name === 'ecc12:Conceptos') {
                    c.elements.forEach(function (c) {
                      if (c.name === 'ecc12:ConceptoEstadoDeCuentaCombustible') {
                        const ecc12Traslados = []
                        c.elements.forEach(function (c) {
                          if (c.name === 'ecc12:Traslados') {
                            c.elements.forEach(function (c) {
                              if (c.name === 'ecc12:Traslado') {
                                totalTrasladados = totalTrasladados + parseFloat(c.attributes.Importe)
                                ecc12Traslados.push(c.attributes)
                              }
                            })
                          }
                        })
                        c.attributes.traslados = ecc12Traslados
                        conceptosEdoCta.push(c.attributes)
                      }
                    })
                  }
                })
                c.attributes.conceptos = conceptosEdoCta
                estadoDeCuentaCombustible = c.attributes
              }
            })
          }
          // datos de los conceptos
          if (o.name === 'cfdi:Conceptos') {
            o.elements.forEach(function (c) {
              conceptos.push(c.attributes)
            })
          }
        })
        // val
        this.model.folio_fiscal = timbreFiscalDigital.UUID
        this.model.numero_factura = xmlObject.attributes.Folio ?? xmlObject.attributes.NoCertificado.slice(-4)
        this.model.es_numero_factura = (xmlObject.attributes.Folio !== undefined)
        this.model.proveedor = emisor.Rfc + ' | ' + emisor.Nombre
        this.model.fInicial = xmlObject.attributes.Fecha
        this.model.concepto_general = conceptos.map(c => c.Descripcion).join(', ')
        this.model.fFactura = xmlObject.attributes.Fecha
        this.model.descuento = xmlObject.attributes.Descuento ?? 0
        this.model.subtotal_impuestos = estadoDeCuentaCombustible.SubTotal ?? xmlObject.attributes.SubTotal
        this.model.total_con_impuestos = estadoDeCuentaCombustible.Total ?? xmlObject.attributes.Total
        this.model.impuestos = totalTrasladados > 0 ? totalTrasladados.toFixed(2) : parseFloat(impuestos.TotalImpuestosTrasladados).toFixed(2)
        this.model.impuestos_retenidos = impuestos.TotalImpuestosRetenidos ?? 0
        this.model.retencion = 0
        this.model.conceptos = conceptos
        this.model.estado_de_cuenta_combustible = estadoDeCuentaCombustible

        fieldMain.isHidden.map((item, i) => {
          this.form.status_finish.formulario.fields.map((form, index) => {
            if (item === form.nameid) {
              if (form.nameid === 'impuestos_retenidos') {
                form.hidden = (!this.model.impuestos_retenidos > 0)
              } else if (form.nameid === 'descuento') {
                form.hidden = (!this.model.descuento > 0)
              } else {
                form.hidden = false
              }
            }
          })
        })
      }
    }
  },
  computed: {
    ...mapGetters(['get_shoeBtnLoading']),
    showdata () {
      return this.model
    }
  },
  watch: {
    get_shoeBtnLoading (val) {
      this.btnloading = val
    }
  }
}
</script>

<style>
.box-color-red {
  border: 1px red solid;
}
div .checkbook-horizontal{
  display: inline-block;
}
.dividerMain{
  border: 2px #757575 solid;
  background-color:#757575
}
</style>
